import { render, staticRenderFns } from "./StatsBuilder.vue?vue&type=template&id=786d460f&scoped=true"
import script from "./StatsBuilder.vue?vue&type=script&lang=js"
export * from "./StatsBuilder.vue?vue&type=script&lang=js"
import style0 from "./StatsBuilder.vue?vue&type=style&index=0&id=786d460f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d460f",
  null
  
)

export default component.exports